export default __webpack_public_path__ + "static/corporate-responsibility-36637caca07dcc51126a2e0364cfba17.webp";